import {Income} from './eligibility-check/income.model';

export enum EmployeeType {
    SelfEmployed = 'SELF_EMPLOYED',
    Professional = 'PROFESSIONAL',
    Salaried = 'SALARIED'
}

export class IncomeToEmployeeTypeConverter {
    static convert(income: Income): EmployeeType {
        return Income.from(income).isMonthly() ? EmployeeType.Salaried : EmployeeType.SelfEmployed;
    }
}
